import axios from 'axios';   

// const BASE_URL = `https://bnlwe-ai04-d-930710-webapi-03.azurewebsites.net/api`; // Dev
// const BASE_URL = `http://127.0.0.1:3001/api`;
// const BASE_URL = `https://bnlwe-ai03-q-931040-webapp-03.azurewebsites.net/api`; //QA
// const BASE_URL = `https://bnlwe-ai01-p-931042-webapp-03.azurewebsites.net/api`; // Prd

const getBaseUrl = () => {
  switch (window.location.hostname) {
    case "localhost":
      return "http://127.0.0.1:3001/api";

    case "aiflmdev.unilever.com":
    case "bnlwe-ai04-d-930633-webapi-02.azurewebsites.net":
      return "https://bnlwe-ai04-d-930710-webapi-03.azurewebsites.net/api";

    case "aiflmuat.unilever.com":
    case "bnlwe-ai03-q-931039-webapi-02.azurewebsites.net":
      return "https://bnlwe-ai03-q-931040-webapp-03.azurewebsites.net/api";

    case "aiflmprod.unilever.com":
    case "bnlwe-ai01-p-930632-webapi-02.azurewebsites.net":
      return "https://bnlwe-ai01-p-931042-webapp-03.azurewebsites.net/api";

    default:
      return "https://bnlwe-ai04-d-930710-webapi-03.azurewebsites.net/api";
  }
};

const BASE_URL = getBaseUrl();

export const getParam2 = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/param2`, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    // const response = await axios.get(`https://bnlwe-ai04-d-930633-webapi-03.azurewebsites.net/ethics/filters`, {
    //     headers: {
    //         Authorization: `Bearer ${token}`
    //     }
    // });
    return response;
  } catch (error) {
    return error;
  }
};

export const getParam3 = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/param3`, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const saveForm = async (token, input1) => {
  try {
    const response = await axios.post(`${BASE_URL}/saveForm`, input1, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const saveData = async (token, input2) => {
  try {
    const response = await axios.post(`${BASE_URL}/saveData`, input2, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const proxyDatabricks = async (token, input3) => {
  try {
    const response = await axios.post(`${BASE_URL}/proxy/databricks`, input3, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getRagConfig = async (token, ragAppName, createdDateTime) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/get-rag-config`,
      {
        params: {
          rag_app_name: ragAppName,
          created_date_time: createdDateTime
        },
        headers: {
          token: token,
          role: 'X-client'
        }
      }
      // {
      //     headers: {
      //         token: token,
      //         role: "X-client"
      //     }
      // }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getIngestionStatus = async (token, ragAppName) => {
  try {
    const response = await axios.get(`${BASE_URL}/get-ingestion-status`, {
      params: {
        rag_app_name: ragAppName
      },
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updateRagConfig = async (token, ragAppName) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/update-rag-config`,
      { rag_app_name: ragAppName },
      {
        headers: {
          token: token,
          role: 'X-client'
        }
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const updateEnabledField = async (token, input) => {
  try {
    const response = await axios.put(`${BASE_URL}/update-enabled-field`, input, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getAdminList = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/adminlist`, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getCompleteList = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/completelist`, {
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getList = async (token, loggedInUser) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/list`,
      { created_by: loggedInUser },
      {
        headers: {
          token: token,
          role: 'X-client'
        }
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const updateAllRagConfig = async (token, ragAppName) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/update-all-rag-config`,
      { rag_app_name: ragAppName },
      {
        headers: {
          token: token,
          role: 'X-client'
        }
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const updateSingleRagStatus = async (token, ragAppName, createdDateTime) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/update-single-rag-status`,
      { rag_app_name: ragAppName, created_date_time: createdDateTime },
      {
        headers: {
          token: token,
          role: 'X-client'
        }
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getRagDetails = async (token, ragAppName, createdDateTime) => {
  try {
    const response = await axios.get(`${BASE_URL}/get-rag-details`, {
      params: {
        rag_app_name: ragAppName,
        created_date_time: createdDateTime
      },
      headers: {
        token: token,
        role: 'X-client'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updateRagAppStatus = async (token, ragAppName, createdDateTime) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-rag-app-status`,
      { rag_app_name: ragAppName, created_date_time: createdDateTime },
      {
        headers: {
          token: token,
          role: 'X-client'
        }
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getRagList = async (token) => {
    try {
        const response = await axios.get(`${BASE_URL}/raglist`, {
            headers: {
                token: token,
                role: "X-client"
            }
        });
        return response;
    } catch (error) {
        return error;
    }
}

//Rag Cost
export const getServiceNames = async (token, loggedInUser) => {
    try {
        const response = await axios.post(`${BASE_URL}/get-service-name`,
            { created_by: loggedInUser },
            {
                headers: {
                    token: token,
                    role: "X-client"
                }
            });
        return response;
    } catch (error) {
        return error;
    }
}

export const getVectorSearchIndex = async (token, input) => {
    try {
        const response = await axios.post(`${BASE_URL}/get-vector-search-index`,
            input,
            {
                headers: {
                    token: token,
                    role: "X-client"
                }
            });
        return response;
    } catch (error) {
        return error;
    }
}

export const getEnvironments = async (token) => {
    try {
        const response = await axios.get(`${BASE_URL}/get-environments`, {
            headers: {
                token: token,
                role: "X-client"
            }
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getServingCost = async (token, input) => {
    try {
        const response = await axios.post(`${BASE_URL}/get-serving-cost`,
            input,
            {
                headers: {
                    token: token,
                    role: "X-client"
                }
            });
        return response;
    } catch (error) {
        return error;
    }
}

export const RagCostAnalysisGraph = async (token, input) => {
    try {
        const response = await axios.post(`${BASE_URL}/rag-cost-analysis-graph`,
            input,
            {
                headers: {
                    token: token,
                    role: "X-client"
                }
            });
        return response;
    } catch (error) {
        return error;
    }
}

export const ragCostAnalysisTable = async (token, input) => {
    try {
        const response = await axios.post(`${BASE_URL}/rag-cost-analysis-table`,
            input,
            {
                headers: {
                    token: token,
                    role: "X-client"
                }
            });
        return response;
    } catch (error) {
        return error;
    }
}
